export const widgetStyles = `
.trainge-chatbot-root {
  --tc-primary: #e6002d;
  --tc-primary-dark: #c90027;
  --tc-border: #dedede;
  --tc-text: #292929;
  --tc-muted: #8b8b8b;
  --tc-bg: #ffffff;
  --tc-panel: #f3f3f3;
  color: var(--tc-text);
  font-family: Arial, "Noto Sans TC", sans-serif;
  position: fixed;
  z-index: 2147483000;
  /* Host 站可從 globals 繼承；standalone embed 用下列 fallback */
  --trainge-chatbot-edge-gap: 12px;
  --trainge-chatbot-panel-viewport-gap: 48px;
  right: var(--trainge-chatbot-widget-right-gap, var(--trainge-chatbot-edge-gap));
  bottom: calc(var(--trainge-chatbot-edge-gap) + var(--trainge-chatbot-bottom-offset, 0px));
}
@media (min-width: 769px) {
  .trainge-chatbot-root {
    --trainge-chatbot-widget-right-gap: 48px;
  }
}
.trainge-chatbot-button {
  width: 58px;
  height: 58px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 50%;
  color: #fff;
  background: var(--tc-primary);
  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.18);
  cursor: pointer;
}
.trainge-chatbot-button svg {
  width: 28px;
  height: 28px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.trainge-chatbot-panel {
  width: calc(
    100vw - var(--trainge-chatbot-edge-gap) - var(--trainge-chatbot-widget-right-gap, var(--trainge-chatbot-edge-gap))
  );
  max-width: 380px;
  height: min(
    620px,
    calc(100dvh - var(--trainge-chatbot-bottom-offset, 0px) - var(--trainge-chatbot-panel-viewport-gap))
  );
  display: none;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid var(--tc-border);
  border-radius: 8px;
  background: var(--tc-bg);
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.2);
}
.trainge-chatbot-root[data-open="true"] .trainge-chatbot-panel {
  display: flex;
}
.trainge-chatbot-root[data-open="true"] .trainge-chatbot-button {
  display: none;
}
.trainge-chatbot-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 56px;
  padding: 0 14px;
  background: #fff;
  color: var(--tc-primary);
  border-bottom: 1px solid #ededed;
}
.trainge-chatbot-title {
  font-size: 15px;
  font-weight: 700;
}
.trainge-chatbot-close {
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 50%;
  background: #f4f4f4;
  color: var(--tc-muted);
  cursor: pointer;
  font-size: 20px;
}
.trainge-chatbot-messages {
  flex: 1;
  overflow-y: auto;
  padding: 16px 14px;
  background: var(--tc-panel);
}
.trainge-chatbot-message {
  max-width: 86%;
  margin: 0 0 10px;
  padding: 10px 12px;
  border-radius: 16px;
  overflow-wrap: anywhere;
  font-size: 14px;
  line-height: 1.45;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
}
.trainge-chatbot-message[data-role="user"] {
  margin-left: auto;
  background: #fff;
  color: var(--tc-text);
  border: 1px solid #ededed;
  white-space: pre-wrap;
}
.trainge-chatbot-message[data-role="assistant"] {
  margin-right: auto;
  background: #fff;
  border: 1px solid #ededed;
}
.trainge-chatbot-message[data-pending="true"] {
  width: 44px;
  min-height: 36px;
  padding: 9px 12px;
}
.trainge-chatbot-progress {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}
.trainge-chatbot-progress-ring {
  width: 16px;
  height: 16px;
  box-sizing: border-box;
  border: 2px solid #f1b6c1;
  border-top-color: var(--tc-primary);
  border-radius: 50%;
  animation: trainge-chatbot-spin 0.8s linear infinite;
}
@keyframes trainge-chatbot-spin {
  to {
    transform: rotate(360deg);
  }
}
.trainge-chatbot-message p,
.trainge-chatbot-message ul,
.trainge-chatbot-message ol,
.trainge-chatbot-message h3,
.trainge-chatbot-message h4,
.trainge-chatbot-message h5 {
  margin: 0 0 8px;
}
.trainge-chatbot-message p:last-child,
.trainge-chatbot-message ul:last-child,
.trainge-chatbot-message ol:last-child,
.trainge-chatbot-message h3:last-child,
.trainge-chatbot-message h4:last-child,
.trainge-chatbot-message h5:last-child {
  margin-bottom: 0;
}
.trainge-chatbot-message ul,
.trainge-chatbot-message ol {
  padding-left: 18px;
}
.trainge-chatbot-message li {
  margin: 3px 0;
}
.trainge-chatbot-message h3,
.trainge-chatbot-message h4,
.trainge-chatbot-message h5 {
  font-size: 14px;
  font-weight: 700;
}
.trainge-chatbot-message code {
  padding: 1px 4px;
  border-radius: 4px;
  background: #f4f4f4;
  font-family: Consolas, Monaco, monospace;
  font-size: 0.92em;
}
.trainge-chatbot-message a {
  color: var(--tc-primary-dark);
  text-decoration: underline;
}
.trainge-chatbot-feedback {
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 26px;
  margin-top: 8px;
}
.trainge-chatbot-feedback-button {
  width: 26px;
  height: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 50%;
  background: transparent;
  color: #777;
  cursor: pointer;
  transition:
    background 120ms ease,
    border-color 120ms ease,
    color 120ms ease,
    transform 80ms ease;
}
.trainge-chatbot-feedback-button:hover {
  background: #f5f5f5;
  color: var(--tc-text);
}
.trainge-chatbot-feedback-button:active {
  transform: scale(0.88);
}
.trainge-chatbot-feedback-button svg {
  width: 17px;
  height: 17px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.trainge-chatbot-feedback[data-feedback-selected="like"] .trainge-chatbot-feedback-button[data-feedback-action="like"],
.trainge-chatbot-feedback[data-feedback-selected="dislike"] .trainge-chatbot-feedback-button[data-feedback-action="dislike"] {
  border-color: rgba(230, 0, 45, 0.24);
  background: #fff0f2;
  color: var(--tc-primary);
}
.trainge-chatbot-feedback-button:disabled {
  cursor: default;
  opacity: 1;
}
.trainge-chatbot-course-image-wrap {
  display: block;
  width: 100%;
  max-width: 100%;
  margin: 8px 0 4px;
}
.trainge-chatbot-course-image {
  display: block;
  width: 100%;
  max-width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  border: 1px solid var(--tc-border);
  border-radius: 8px;
  background: #f4f4f4;
}
.trainge-chatbot-composer {
  display: flex;
  flex-direction: column;
  padding: 10px 12px 12px;
  border-top: 1px solid #e9e9e9;
  background: #fff;
}
.trainge-chatbot-input-wrap {
  position: relative;
  display: flex;
  width: 100%;
}
.trainge-chatbot-input {
  width: 100%;
  box-sizing: border-box;
  height: 44px;
  min-height: 44px;
  max-height: 104px;
  resize: none;
  overflow-y: hidden;
  border: 1px solid var(--tc-border);
  border-radius: 18px;
  padding: 10px 76px 10px 14px;
  font: inherit;
  line-height: 1.45;
  outline: none;
}
.trainge-chatbot-input:focus {
  border-color: #cfcfcf;
  box-shadow: 0 0 0 2px rgba(230, 0, 45, 0.08);
}
.trainge-chatbot-icon-button,
.trainge-chatbot-send {
  border: 0;
  border-radius: 50%;
  cursor: pointer;
  font: inherit;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.trainge-chatbot-icon-button {
  position: absolute;
  right: 42px;
  bottom: 9px;
  width: 26px;
  height: 26px;
  background: transparent;
  color: #777;
}
.trainge-chatbot-icon-button svg {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2.4;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.trainge-chatbot-icon-button[data-recording="true"] {
  background: #fff0f2;
  color: var(--tc-primary);
}
.trainge-chatbot-send {
  position: absolute;
  right: 10px;
  bottom: 9px;
  width: 26px;
  height: 26px;
  background: transparent;
  color: var(--tc-primary);
}
.trainge-chatbot-send svg {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2.2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.trainge-chatbot-send:disabled,
.trainge-chatbot-icon-button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}
`;
